var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMinusOctagon = function SvgMinusOctagon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 21,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.667,
    d: "M6.667 10.425h6.666M3.23 15.32l1.875 1.876c.577.577.865.865 1.202 1.071.298.183.623.317.963.4.384.091.791.091 1.607.091h2.248c.815 0 1.223 0 1.607-.092a3.3 3.3 0 0 0 .963-.399c.336-.206.625-.494 1.201-1.07l1.876-1.877c.577-.576.865-.864 1.071-1.2q.275-.452.4-.964c.091-.384.091-.792.091-1.607V9.301c0-.816 0-1.223-.092-1.607a3.3 3.3 0 0 0-.399-.963c-.206-.337-.494-.625-1.07-1.202l-1.877-1.875c-.576-.577-.864-.865-1.2-1.071a3.3 3.3 0 0 0-.964-.4c-.384-.091-.792-.091-1.607-.091H8.876c-.816 0-1.223 0-1.607.092-.34.081-.665.216-.963.399-.337.206-.625.494-1.202 1.07L3.23 5.53c-.577.577-.865.865-1.071 1.202a3.3 3.3 0 0 0-.4.963c-.091.384-.091.791-.091 1.607v2.248c0 .815 0 1.223.092 1.607.081.34.216.665.399.963.206.337.494.625 1.07 1.201Z"
  })));
};
export default SvgMinusOctagon;